import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  isSowingDetailsLoading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_SCHEDULE_SUCCESS:
    case actionTypes.FETCH_SCHEDULE_ERROR:
      if (action.payload.type === 'SOWING_DETAILS') {
        return action.payload;
      }
      return state;
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.FETCH_SCHEDULE:
          return Object.assign({}, state, { isSowingDetailsLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.FETCH_SCHEDULE:
          return Object.assign({}, state, { isSowingDetailsLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
